import React from 'react';
import PropTypes from 'prop-types';
import pageWrapper from '../../hoc/pageWrapper';
import ArticleDetails from '../../components/articleDetails/articleDetails';

const Article = ({
	page,
}) => {
	return (
		<ArticleDetails
			Name={page.Name}
			{...page.Values} />
	);
};

Article.propTypes = {
	page: PropTypes.object
};

Article.defaultProps = {
	page: null
};

export default pageWrapper(Article);
